import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormMetricsChartType } from 'services/models/form-builder/form-metrics/form-metrics.enum';
import { FormMetricsCategoryClickEvent } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsRespondentAnswerItemModel } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';

@Component({
  selector: 'app-form-metrics-item-widget',
  templateUrl: './form-metrics-item-widget.component.html',
  styleUrls: ['./form-metrics-item-widget.component.scss'],
})
export class FormMetricsItemWidgetComponent {
  @Input() item: FormMetricsItemModel;
  @Input() highlightedEmployeeId: string | null = null;
  @Input() categoryClickEnabled = false;
  @Input() highlightAnswers: FormMetricsRespondentAnswerItemModel[] = [];
  @Output() openComments = new EventEmitter<FormMetricsItemModel>();
  @Output() categoryClick = new EventEmitter<FormMetricsCategoryClickEvent>();

  readonly chartTypes = FormMetricsChartType;

  onViewAllComments(item: FormMetricsItemModel): void {
    this.openComments.emit(item);
  }

  onCategoryClick(event: FormMetricsCategoryClickEvent): void {
    this.categoryClick.emit(event);
  }
}
